import classes from "./Section1.module.css";

export default function Section1() {
  return (
    <section className={classes.bannerWrapper}>
      {/* Video Background */}
      <video
        className={classes.bannerVideo}
        src="/video/about-banner-video.mp4"
        autoPlay
        muted
        loop
      />
      {/* Overlay */}
      <div className={classes.bannerOverlay}></div>

      {/* Content */}
      <div className={classes.bannerContent}>
        <h1 className={classes.bannerTitle}>About</h1>
        <p className={classes.bannerDescription}>
          TechMatter is a computer and computer hardware reseller and supplier
          situated in the United Kingdom. The organization is a pioneer in
          delivering high-quality products from a variety of well-known brands
          to your home.
        </p>
      </div>
    </section>
  );
}
